import { EProductStatus } from "@api/models/IProduct";
import Icon from "@core-components/icon/Icon";
import ProductDetailLine from "@core-components/product-detail-line/ProductDetailLine";
import SSTooltip from "@core-components/tooltip/Tooltip";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import {
  IconBolt,
  IconDroplet,
  IconMail,
  IconShieldCheck,
  IconWorld,
} from "@tabler/icons-react";

interface ISSProductDetailLines {
  blueEssence?: string;
  region: string;
  i18nKey: string;
  status: EProductStatus;
  isSkinCard?: boolean;
  warantyText?: string[];
}

const SSProductDetailLines: React.FC<ISSProductDetailLines> = ({
  blueEssence,
  i18nKey,
  status,
  isSkinCard,
  warantyText,
}) => {
  const { t } = useAppTranslation("components.productDetailLines");
  const productT = useAppTranslation();

  const { currentRegion } = useAppRegion();

  // Get translated values from i18n
  const rank = productT.t(`${i18nKey}.rank`, {
    region: currentRegion.toUpperCase(),
  });
  const emailState = productT.t("common.emailStatus");
  const mmr = productT.t(`${i18nKey}.mmr`, {
    defaultValue: "",
    region: currentRegion.toUpperCase(),
  });
  const mmrTooltip = productT.t(`${i18nKey}.mmr_tooltip`, {
    defaultValue: "",
    region: currentRegion.toUpperCase(),
  });

  const defaultWarrantyText = t("warrantyText", {
    returnObjects: true,
  }) as string[];
  const finalWarrantyText = warantyText || defaultWarrantyText;

  return (
    <>
      <ProductDetailLine
        key={1}
        color="#FF7A00"
        description={currentRegion.toUpperCase()}
        icon={IconWorld}
        label={t("region")}
      />

      {blueEssence && (
        <ProductDetailLine
          key={2}
          color="#60A9FF"
          description={blueEssence}
          icon={IconDroplet}
          label={t("blueEssence")}
        />
      )}

      <ProductDetailLine
        key={3}
        color="#00B67A"
        description={
          status === EProductStatus.SEMI_READY ? (
            <SSTooltip
              label={rank}
              text={t("rankTooltip", { returnObjects: true }) as string[]}
            />
          ) : (
            rank
          )
        }
        icon={IconBolt}
        label={t("rank")}
      />

      {mmr && (
        <ProductDetailLine
          key={4}
          color="#ABA136"
          description={<SSTooltip label={mmr} text={[mmrTooltip]} />}
          icon={Icon.MMR}
          iconClassName={"h-[15px]"}
          label={t("mmr")}
        />
      )}

      {!isSkinCard && (
        <ProductDetailLine
          key={6}
          color="#AB364E"
          description={
            <SSTooltip label={t("lifetimeWarranty")} text={finalWarrantyText} />
          }
          icon={IconShieldCheck}
          label={t("warranty")}
        />
      )}

      {emailState && (
        <ProductDetailLine
          key={7}
          color="#5559BD"
          description={emailState}
          icon={IconMail}
          label={t("email")}
        />
      )}
    </>
  );
};

export default SSProductDetailLines;
